import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// --- Amplitude Analytics + Session Replay ---
import * as amplitude from "@amplitude/unified";

const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
if (!apiKey) {
  console.warn("Amplitude API key missing — analytics disabled");
} else {
  amplitude.initAll(apiKey, {
    analytics: { autocapture: true },
    sessionReplay: { sampleRate: 1 },
  });

  // First verification event
  amplitude.track("Viewed Home Page", { prompt_version: "BA400.4" });
}
// ---------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
